export default function WhyCorporateTraining() {
  const reasons = [
    { icon: 'ri-building-2-line', title: 'Единая система управления', desc: 'Корпоративный формат позволяет выстроить общую методологию, язык и стандарты для всех руководителей компании.' },
    { icon: 'ri-focus-3-line', title: 'Привязка к реальным задачам', desc: 'Программа строится на кейсах и проблемах именно вашей компании, а не на абстрактных примерах из учебников.' },
    { icon: 'ri-group-line', title: 'Командная динамика', desc: 'Руководители проходят обучение вместе, что формирует cross-функциональные связи и разрушает барьеры между отделами.' },
    { icon: 'ri-bar-chart-box-line', title: 'Измеримый ROI', desc: 'В отличие от открытых тренингов, корпоративное обучение замеряется по бизнес-показателям: текучесть, KPI, eNPS.' },
    { icon: 'ri-loop-right-line', title: 'Долгосрочный эффект', desc: 'Сопровождение после тренинга и внедрение инструментов дают устойчивые изменения, а не краткосрочный всплеск мотивации.' },
    { icon: 'ri-price-tag-3-line', title: 'Экономическая эффективность', desc: 'Обучение группы руководителей в корпоративном формате выгоднее, чем отправка каждого на открытые курсы.' },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Почему компании выбирают именно корпоративное обучение руководителей
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto">
          Корпоративный формат — это не просто «тренинг в офисе». Это стратегический инструмент трансформации бизнеса через развитие управленческой команды
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {reasons.map((item, i) => (
            <div key={i} className="bg-gray-50 p-7 rounded-xl hover:bg-teal-50 transition-colors group text-center">
              <div className="w-14 h-14 bg-teal-600 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                <i className={`${item.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{item.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}